<template>
  <div class="content" >
    <div v-if="$store.state.utils.configuration.enableNewNoWebglModal">
      <div class="new-modal-error-icon">!</div>
      <h2 class="new-modal-title">{{ translations.oldBrowserHeader }}</h2>
      <p class="new-modal-description">
        {{ translations.oldBrowserDescription }}
      </p>
    </div>
    <h5 class="text-center subheader" v-else>
      {{ translations.noWebglSubHeader1 }}<br/>
      {{ translations.noWebglSubHeader2 }}
      {{ translations.noWebglSubHeader3 }}<br/>
    </h5>
  </div>
</template>

<script>
export default {
  name: "noWebglModal",
  computed: {
    translations(){
      return this.$store.state.translations.data;
    }
  },
  methods: {
    /**
     * @function ctaAction
     * Method for the CTA button.
     */
    ctaAction() {
      window.open("https://www.google.com/chrome/browser/", "_blank");
    }
  }
};
</script>
